import { render } from "./ChooseJobPopup.vue?vue&type=template&id=472f3e00"
import script from "./ChooseJobPopup.vue?vue&type=script&lang=js"
export * from "./ChooseJobPopup.vue?vue&type=script&lang=js"

import exportComponent from "/home/treim/code/trit/reclo/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__